import React, { useEffect, useState } from "react";
import { apiClient } from "../../../lib/api";
import { useI18n } from "../../../lib/i18n";
import { Star } from "lucide-react";

export default function DashReviews({ businessId }) {
  const { lang } = useI18n();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get(`/platform/dashboard/business/${businessId}/reviews`)
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, [businessId]);

  if (loading) return <div className="text-[#8a8a8a]">…</div>;
  const s = data?.summary || {};
  const items = data?.items || [];

  return (
    <div className="space-y-6" data-testid="dash-reviews">
      <div className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-4">
        <div className="rounded-2xl p-5 border border-[#0a0a0a]/[0.06]" style={{ background: "linear-gradient(135deg,#0a0a0a,#1f1614)" }}>
          <div className="text-[#f7eecd]/70 text-[11px] uppercase font-semibold">{lang === "ar" ? "المتوسط" : "Average"}</div>
          <div className="text-5xl font-bold font-display text-[#f7eecd] mt-1">{s.average ?? "—"}</div>
          <div className="flex items-center gap-0.5 mt-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className="w-3.5 h-3.5" fill={s.average >= i ? "#e8c873" : "none"} stroke="#e8c873" strokeWidth={1.5} />
            ))}
          </div>
          <div className="text-[11px] text-[#f7eecd]/60 mt-2">{s.total || 0} {lang === "ar" ? "تقييم" : "reviews"}</div>
        </div>

        <div className="rounded-2xl bg-white border border-[#0a0a0a]/[0.06] p-5">
          <div className="text-[11px] uppercase tracking-widest font-bold text-[#8a6f2e] mb-3">
            {lang === "ar" ? "توزيع النجوم" : "Rating distribution"}
          </div>
          {[5, 4, 3, 2, 1].map((star) => {
            const count = (s.breakdown && s.breakdown[String(star)]) || 0;
            const pct = s.total ? Math.round((count / s.total) * 100) : 0;
            return (
              <div key={star} className="flex items-center gap-3 mb-2">
                <div className="text-[12px] font-mono text-[#525252] w-6">{star}★</div>
                <div className="flex-1 h-2 rounded-full bg-[#f0eee7] overflow-hidden">
                  <div className="h-full" style={{ width: `${pct}%`, background: "linear-gradient(90deg,#e8c873,#8a6f2e)" }} />
                </div>
                <div className="text-[11px] text-[#8a8a8a] w-10 text-end">{count}</div>
              </div>
            );
          })}
        </div>
      </div>

      {items.length === 0 ? (
        <div className="rounded-2xl bg-white border border-dashed border-[#0a0a0a]/10 p-10 text-center text-[#8a8a8a]">
          {lang === "ar" ? "لا توجد تقييمات بعد" : "No reviews yet"}
        </div>
      ) : (
        <div className="rounded-2xl bg-white border border-[#0a0a0a]/[0.06]">
          {items.map((r) => (
            <div key={r.id || r._id} className="p-4 border-b last:border-b-0 border-[#0a0a0a]/[0.06]">
              <div className="flex items-center justify-between mb-1">
                <div className="text-sm font-semibold">{r.reviewer_name || (lang === "ar" ? "عميل" : "Customer")}</div>
                <div className="flex items-center gap-0.5">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star key={i} className="w-3 h-3" fill={r.rating >= i ? "#c9a55c" : "none"} stroke="#c9a55c" strokeWidth={1.5} />
                  ))}
                </div>
              </div>
              {r.text && <div className="text-sm text-[#525252]">{r.text}</div>}
              <div className="text-[10px] text-[#8a8a8a] mt-1">{r.created_at?.slice(0, 10)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
